import React, { Fragment, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../Components/modal.css";
import "./details.css";
import moment from "moment";
import { LanguageContext } from "../context/LanguageContext";
import auditTranslations from "../languages/audit.json";

export const AuditLogDetails = ({ open, log, onClose }) => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t =
    auditTranslations[lang]?.auditLogDetails ||
    auditTranslations.en.auditLogDetails;

  if (!open || !log) return null;

  const handleViewUser = () => {
    if (log.user_id) {
      navigate(`/administration/users/details/${log.user_id}`);
    }
  };

  const handleViewDevice = () => {
    if (log.modified_id) {
      navigate(`/devices/details/${log.modified_id}`);
    }
  };

  const statusLabel =
    t.statuses[String(log.status || "").trim().toLowerCase()] || log.status || "";

  return (
    <Fragment>
      <div id="modal" onClick={onClose}>
        <div
          id="popup"
          className="dashboard-modal auditlog-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dashboard-header">
            <div className="dashboard-header-text">
              <h2>{t.title}</h2>
              <p>{t.subtitle}</p>
            </div>
          </div>

          <div className="modal-divider" />

          <div className="modal-content">
            <div className="dashboard-content auditlog-content">
              <div className="modal-info auditlog-info-banner">
                <div className="auditlog-info-icon">i</div>
                <div className="auditlog-info-text">
                  <h4>{t.infoTitle}</h4>
                  <p>{t.infoMessage}</p>
                </div>
              </div>

              <div className="auditlog-sections">
                <div className="auditlog-row-grid">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.logId}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={log.audit_log_id ?? ""}
                    />
                  </div>

                  <div className="form-item">
                    <span className="form-lbl">{t.fields.modifiedId}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={
                        log.modified_id !== null && log.modified_id !== undefined
                          ? log.modified_id
                          : ""
                      }
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>
                </div>

                <div className="auditlog-row-grid">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.userName}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={log.user_name || ""}
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>

                  <div className="form-item">
                    <span className="form-lbl">{t.fields.userEmail}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={log.user_email || ""}
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>
                </div>

                <div className="auditlog-row-grid">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.userId}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={
                        log.user_id !== null && log.user_id !== undefined
                          ? log.user_id
                          : ""
                      }
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>

                  <div className="form-item">
                    <span className="form-lbl">{t.fields.status}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={statusLabel}
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>
                </div>

                <div className="auditlog-row-grid">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.action}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={log.action || ""}
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>

                  <div className="form-item">
                    <span className="form-lbl">{t.fields.type}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={log.type || ""}
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>
                </div>

                <div className="auditlog-row-grid auditlog-row-single">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.createdAt}</span>
                    <input
                      className="add-column"
                      readOnly
                      value={
                        log.created_at
                          ? moment(log.created_at).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )
                          : ""
                      }
                      placeholder={t.placeholders.notAvailable}
                    />
                  </div>
                </div>

                <div className="form-section auditlog-description-section">
                  <div className="form-item">
                    <span className="form-lbl">{t.fields.description}</span>
                    <textarea
                      className="add-column auditlog-description-field"
                      readOnly
                      value={log.description || ""}
                      placeholder={t.placeholders.noDescription}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer auditlog-footer">
            <div className="auditlog-footer-left">
              <button
                className="btn btn-apply btn-view-user"
                onClick={handleViewUser}
                disabled={!log.user_id}
              >
                {t.buttons.viewUser}
              </button>
              <button
                className="btn btn-apply"
                onClick={handleViewDevice}
                disabled={!log.modified_id}
              >
                {t.buttons.viewDevice}
              </button>
            </div>

            <div className="auditlog-footer-right">
              <button className="btn btn-cancel" onClick={onClose}>
                {t.buttons.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AuditLogDetails;
